import React from 'react';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';
import { Dropdown, Input } from 'semantic-ui-react';
import Customerdetails from '../../others/customerdetails';

class PartView extends React.Component {

  state = {
    data: [],
    dialog: false,
    maxWidth: 'lg',
    fullWidth: true,
    filter: 'Waiting',
    search: ''
  }

  componentDidMount() {
    this.getdate();
  }

  getdate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) { dd = '0' + dd; }
    if(mm < 10) { mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    let from = yyyy+'-'+mm+'-01';
    this.setState({ from: from, to: today })
    today = yyyy+'-'+mm+'-'+dd+' 23:59:59';
    from = yyyy+'-'+mm+'-01 00:00:00';
    this.setState({ toDate: today, fromDate: from })
  }

  viewPart() {
    this.get(this.state.toDate, this.state.fromDate, this.state.filter);
  }

  get(todate, fromdate, status) {
    let context = this;
    context.setState({ load: true, message: 'Getting Parts!!!!' });
    $.ajax({
      method: 'POST',
      data: {'toDate': context.state.toDate, 'fromDate': context.state.fromDate, 'status': status, 'search': context.state.search },
      url: Server() + 'orderstatus/getpart.php',
      success: function(data) {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.setState({ data: data, dialog: true })
        } catch (e) {
        }
      },
      error: function(error) {
        alert('Try Again!!!');
        console.log(error);
        context.setState({ load: false });
      }
    })
  }

  changeHandle = (type) => event => {
    this.setState({ [type]: event.target.value })
    if (type == 'from') {
      let from = event.target.value+' 00:00:00';
      this.setState({ fromDate: from })
    }
    else {
      let to = event.target.value+' 23:59:59';
      this.setState({ toDate: to })
    }
  }

  filter = (f, { value }) => {
    this.setState({ filter: value });
  }

  onChangeHandle = (type) => event => {
    this.setState({ [type]: event.target.value })
  }

  render() {
    let i = 1;
    let menuOption = [
      { key: 'Waiting', text: 'Waiting', value: 'Waiting' },
      { key: 'Approved', text: 'Approved', value: 'Approved' },
      { key: 'Pending For Delivery', text: 'Pending For Delivery', value: 'Pending For Delivery' },
      { key: 'Prior Order', text: 'Prior Order', value: 'Prior Order' },
      { key: 'Delivered', text: 'Delivered', value: 'Delivered' },
      { key: 'Canceled', text: 'Canceled', value: 'Canceled' },
    ];
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Button color='primary' variant='outlined' onClick={this.viewPart.bind(this)}>View Part</Button>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.state.dialog}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">
          <div style={{display: 'flex'}}>
          Part Details
          <div style={{paddingLeft: '2%'}}>
          <input type='date' style={{fontSize: 16}} value={this.state.from} onChange={this.changeHandle('from')} />
          <input type='date' style={{fontSize: 16}} value={this.state.to} onChange={this.changeHandle('to')} />
          <Input style={{fontSize: 20, height: 19}} placeholder='search' onChange={this.onChangeHandle('search')} value={this.state.search} />
          <Dropdown id="Control" onChange={this.filter}
            search selection options={menuOption}
            value={this.state.filter} style={{fontSize: 12}} />
          <Button color='primary' variant='outlined' onClick={this.viewPart.bind(this)}>Search</Button>
          </div>
          </div>
          </DialogTitle>
          <DialogContent>
            <table id='table' width='100%'>
              <tr>
                <th id='th'><center>Sino</center></th>
                <th id='th'><center>Customer</center></th>
                <th id='th'><center>Taluk</center></th>
                <th id='th'><center>Part</center></th>
                <th id='th'><center>Status</center></th>
                <th id='th'><center>Uprice</center></th>
                <th id='th'><center>Total Amount</center></th>
              </tr>
              { this.state.data.map((c) => {
                  return (
                    <tr>
                      <td><center>{i++}</center></td>
                      <td>
                        <Customerdetails customerName={c.name} customerId={c.id} />
                      </td>
                      <td>{c.taluk}</td>
                      <td>{c.partno+"->"+c.spare_name}</td>
                      <td>{c.status}</td>
                      <td style={{textAlign: 'right'}}>{this.convertToNumber(c.uprice)}</td>
                      <td style={{textAlign: 'right'}}>{this.convertToNumber(c.totprice)}</td>
                    </tr>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  convertToNumber(value) {
    try {
      value = Number(value);
      value = value.toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }
}

export default PartView;
